import { render, staticRenderFns } from "./ModalResetQuesNumStdbQuestion.vue?vue&type=template&id=e0d167b2&scoped=true"
import script from "./ModalResetQuesNumStdbQuestion.vue?vue&type=script&lang=js"
export * from "./ModalResetQuesNumStdbQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalResetQuesNumStdbQuestion.vue?vue&type=style&index=0&id=e0d167b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d167b2",
  null
  
)

export default component.exports